import { render } from "./List1.vue?vue&type=template&id=c33b235e"
import script from "./List1.vue?vue&type=script&lang=js"
export * from "./List1.vue?vue&type=script&lang=js"

import "./List1.vue?vue&type=style&index=0&id=c33b235e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__